import { z } from 'zod';
import { imageReferenceSchema } from './common.js';
export const uploadMediaTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const uploadMediaTypeSchema = z.enum(uploadMediaTypes);
export const uploadResponseSchema = z.object({
    url: imageReferenceSchema,
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    mediaType: uploadMediaTypeSchema,
    bytes: z.number().int().positive(),
});
export const imageUploadResponseSchema = uploadResponseSchema;
//# sourceMappingURL=uploads.js.map